import JobStatus from '@/models/Jobs/JobStatus';

export default class JobStatusViewModel {
    name: string;
    value: JobStatus;

    public constructor(name: string, value: JobStatus) {
        this.name = name;
        this.value = value;
    }
}